import { render, staticRenderFns } from "./CustomDataMenu.vue?vue&type=template&id=bee61300&"
import script from "./CustomDataMenu.vue?vue&type=script&lang=js&"
export * from "./CustomDataMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomDataMenu.vue?vue&type=style&index=0&id=bee61300&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports